import {deserialize, serialize, inheritSerialization, deserializeAs} from "cerialize";
import moment from "moment";

import BaseEntity from "./BaseEntity";
import Soal from "./Soal";
import TableColumn from "./TableColumn";
import AppConfig from "../AppConfig";

@inheritSerialization(BaseEntity)
export default class JawabanBankSoal extends BaseEntity {

    @serialize
    @deserialize
    public bank_soal_id: number = 0;

    @deserialize
    public bank_soal_nama: string = "";

    @deserialize
    public pendidikan: string = "";

    @deserialize
    public tahun: string = "";

    @serialize
    @deserialize
    public nomor: string = "";

    @serialize
    @deserialize
    public nama_lengkap: string = "";

    @serialize
    @deserialize
    public jenis_kelamin: string = "";

    @serialize
    @deserialize
    public orang_tua: string = "";

    @serialize
    @deserialize
    public sekolah_asal: string = "";

    @deserialize
    public total_benar: number = 0;

    @deserialize
    public total_salah: number = 0;

    @deserialize
    public catatan: string = "";

    @deserialize
    public created_at: string = "";

    @serialize
    @deserializeAs(Soal)
    public jawabans: Array<Soal> = [];

    @deserializeAs(Soal)
    public jawaban: Array<Soal> = [];

    public table() {
        const {
            bank_soal_nama,
            pendidikan,
            tahun,
            nomor,
            nama_lengkap,
            jenis_kelamin,
            orang_tua,
            sekolah_asal,
            created_at
        } = this;

        return {
            bank_soal_nama,
            pendidikan,
            tahun,
            nomor,
            nama_lengkap,
            jenis_kelamin,
            orang_tua,
            sekolah_asal,
            created_at: created_at ? moment(created_at).format("DD MMM YYYY HH:mm") : ""
        };
    }

    public static columnName(): Array<TableColumn> {
        const table = new JawabanBankSoal().table();
        const keys = Object.keys(table);

        return keys.map((field: string) => {
            const tableColumn = new TableColumn();
            tableColumn.name = AppConfig.getVm().$t(`label.${field}`);

            if (field === "pendidikan" || field === "tahun" || field === "jenis_kelamin" || field === "created_at") {
                tableColumn.position = "centered";
            }

            return tableColumn;
        });
    }

}
